(function slider() {
  function init() {
    var elements = document.querySelectorAll('[data-module-slider]');

    if (!elements.length) {
      return;
    }

    elements.forEach(sliderOptionsFunc);

    function sliderOptionsFunc(item) {
      var options = item.getAttribute('data-module-slider');
      options = JSON.parse(options || '{}');

      $(item).slick({
        arrows: options.arrows,
        dots: options.dots,
        fade: options.fade,
        autoplay: options.autoplay,
        autoplaySpeed: options.autoplay,
        slidesToShow: options.slidesToShow,
        slidesToScroll: options.slidesToScroll,
        infinite: options.infinite,
        desktopUnslick: options.unslick, 
        centerPadding: options.centerPadding,
        centerMode: options.centerMode,
        asNavFor: options.asNav,
        focusOnSelect: options.focusClick,
        lazyLoad: options.lazyLoad,
        variableWidth: options.variableWidth,
        responsive: [
          {
            breakpoint: 600,
            settings: {
              slidesToShow: options.mobileslidesToShow,
              slidesToScroll: options.mobileslidesToScroll,
              dots: options.mobileDots,
              arrows: options.mobileArrows,
              centerPadding: options.mobilecenterPadding,
              centerMode: options.mobileCenterMode,
              fade: options.mobileFade
            }
          },
          {
            breakpoint: 1300,
            settings: {
              slidesToShow: options.tabletslidesToShow,
              slidesToScroll: options.tabletslidesToScroll,
              centerPadding: options.tabletcenterPadding,
              centerMode: options.tabletCenterMode,
              dots: options.tabletDots,
              arrows: options.tabletArrows
            }
          },
          {
            breakpoint: 1550,
            settings: {
              centerPadding: options.midCenterPadding
            }
          }
        ]
      });
    }
  }

  $(document).ready(init);
})();
